import { SessionProvider } from "@/app/auth/SessionProvider";
import { NavParent } from "@/app/NavContext";
import { theme } from "@/app/theme";
import { NavbarLinkProps } from "@saas-ui/core/src/navbar/navbar-link";
import { ModalsProvider, SaasProvider } from "@saas-ui/react";
import React, { Suspense } from "react";
import { Link } from "react-router";

const NextLink = React.forwardRef<HTMLAnchorElement, NavbarLinkProps>(
  (props, ref) => {
    const { href, ...rest } = props as any;
    return <Link ref={ref} to={href!} {...rest} />;
  }
);

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SaasProvider linkComponent={NextLink} theme={theme}>
      <ModalsProvider>
        <SessionProvider>
          <Suspense>
            <NavParent>{children}</NavParent>
          </Suspense>
        </SessionProvider>
      </ModalsProvider>
    </SaasProvider>
  );
}
